import styled, { DefaultTheme, withTheme } from 'styled-components';

import useI18n from '../../common/hooks/useI18n';

import SectionTitle from './sectionTitle';
import { Faq } from '../shared';

type Props = {
  query: string;
  theme: DefaultTheme;
};

const FaqContainer = styled.div`
  max-width: 64vw;
  margin-left: auto;
  margin-right: auto;

  @media ${(props) => props.theme.breakpoints.mdd} {
    max-width: 80vw;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    max-width: unset;
  }
`;

const FaqSection: React.FC<Props> = ({ query, theme }) => {
  const i18n = useI18n();

  return (
    <>
      <SectionTitle title={i18n.t(`dynamic.sellHousePage.${query}.faqTitle`)} />

      <FaqContainer>
        <Faq spreadsheetName="sellHousePage" query={query} theme={theme} />
      </FaqContainer>
    </>
  );
};

export default withTheme(FaqSection);
